module.exports = __webpack_public_path__ + "static/media/value-ic.b63da2c9.png";